<template>
  <div class="help">
    <van-sticky>
      <van-nav-bar title="互助保障申请指南" left-arrow @click-left="onClickLeft" />
    </van-sticky>
    
    <img src="@/assets/images/help.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'help',
  created(){
    let title = "互助保障申请指南";
    if (this.$getUA() === 1) {
        this.$callApp("Android", "onJSAppSetTitle", title); //调用安卓的设置标题方法
        this.$callApp("Android", "SetWebViewZoom", true)
    }else if (this.$getUA() === 2){
        this.$callApp("iOS", "getWebViewTitleMethod", title); //调用IOS设置标题的方法
        this.$callApp("iOS", "EnableWebZoomMethod", true)
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
  },
}
</script>

<style lang="less" scoped>
img{
  width: 100%;
  height: auto;
  margin-bottom: -3.5px;
}
</style>
